/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const schemeLocationChangeImpactSchema = z.object({
  affectedCount: z.int(),
  countryCode: z.string(),
  isTargetOrgDefault: z.boolean(),
  isTargetSynced: z.boolean(),
  locationId: z.int(),
  subdivisionCode: z.string().nullish(),
  syncedCount: z.int(),
  targetSchemeId: z.int().nullish(),
  targetSchemeName: z.string().nullish(),
});
